export interface OnboardingData {
  // Phase 2: User Info
  firstName: string
  lastName: string
  alias: string
  username: string
  email: string
  profile: string
  role: string

  // Phase 5: Additional Fields
  statesLicensed: string[]
  leadSkills: string[]
  eligiblePullStages: string[]
  loanAmountRange: string[]
  team: string
  applicationLink: string
  ultimateMaxLeads: number | ''

  // Phase 6: Call Center & Groups
  callCenter: string
  publicGroups: string[]

  // Loan Type Capacities
  loanTypeCapacities: Record<string, { dailyMaxLeads: number; active: boolean }>

  // Phase 7: Package Licenses
  packageLicenses: string[]

  // Phase 8: Permission Sets
  permissionSets: string[]
}

export const initialOnboardingData: OnboardingData = {
  firstName: '',
  lastName: '',
  alias: '',
  username: '',
  email: '',
  profile: '',
  role: '',
  statesLicensed: [],
  leadSkills: [],
  eligiblePullStages: [],
  loanAmountRange: [],
  team: '',
  applicationLink: '',
  ultimateMaxLeads: '',
  callCenter: '',
  publicGroups: [],
  loanTypeCapacities: {},
  packageLicenses: [],
  permissionSets: ['Sales User'], // Default selected
}

export interface StepProps {
  data: OnboardingData
  updateData: (updates: Partial<OnboardingData>) => void
  setCanAdvance: (canAdvance: boolean) => void
}
